import $ from "jquery";

class ToggleClass {

    constructor() {
        this.handleToggle();
    }

    handleToggle() {
        $(document).ready(() => {
            $("[data-toggleClass]").on("click", (event) => {
                const toggleClass = $(event.currentTarget).attr("data-toggleClass");
                const toggleElement = $(event.currentTarget).attr("data-toggleElement");

                if (toggleElement && toggleClass) $(toggleElement).toggleClass(toggleClass);

                return false;
            });

            $("[data-toggleSlide]").on("click", (event) => {
                const toggleElement = $(event.currentTarget).attr("data-toggleSlide");

                if (toggleElement) $(toggleElement).slideToggle();

                return false;
            });
        });
    }
}

export default new ToggleClass();
